
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('education')

export default {
  name: 'StreamListChangeSelection',

  props: {
    blockData: {
      type: Object,
      required: true,
      default: () => ({})
    },

    refreshTab: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      i18n: 'pages.education.courses-list.gu-stream-lists',
      isModalVisible: false
    }
  },

  computed: {
    ...mapState(['streamLists']),

    isStreamList() {
      return !!this.blockData?.streamListsForChange?.length
    },

    currentStreamList() {
      return this.streamLists[this.blockData.currentStreamList]
    },

    streamListsForChange() {
      return [
        ...this.blockData.streamListsForChange,
        this.blockData.currentStreamList
      ].sort((a, b) => a - b)
    }
  },

  methods: {
    closeModal() {
      this.isModalVisible = false
    }
  }
}
